import { Injectable } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../shared/constants/api-constants';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { ChangeControlSearch } from '../models/change-control-search';
import { ResponsibleSubBUService } from '../../shared/services/responsible-sub-bu.service';
import { ChangeRegisterConstants } from '../change-register-constants';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';
import { SearchMapperService } from '../../shared/services/search-mapper.service';
import { BaseSearchRequest } from '../../shared/models/search/base-search-request';
import { PaginationState } from "../../shared-components/panel-hub/models/pagination-state";
import { ChangeControlQueryResult } from "../../change-control-catalogue/models/change-control-query-result"

@Injectable({
  providedIn: 'root'
})
export class ChangeRegisterService {
  eQMSScopesForchangeControlSearch: IEQMSScopeLookUpDetails[] = [];
  resposibleSubBUList: any = [];

  constructor(private httpClient: HttpClient, private subBUService: ResponsibleSubBUService, private searchMapper: SearchMapperService) { }
  getchangeControlSearch(changeControlSearchCriteria: ChangeControlSearch): Observable<any> {
    return this.httpClient.post(ApiConstants.ChanageRegister_Search_Api, changeControlSearchCriteria);
  }

  geteQMSScopesForChangeControlSearch = () => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForchangeControlSearch.length > 0) {
      observable = of(this.eQMSScopesForchangeControlSearch);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>
      (ApiConstants.ChanageControl_Scopes_Api.replace('{source}',
        ChangeRegisterConstants.SourceForScopes_From_Search))
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForchangeControlSearch = eQMSScopes)
        );
    }
    return observable;
  }

  getsubBuMasterData(): Observable<any> {
    if (this.resposibleSubBUList.length === 0) {
      return this.subBUService.getSubBU().pipe(
        map((subBuData) => {
          for (let dataItem of subBuData) {
            this.resposibleSubBUList.push({
              value: dataItem.Code + ' ' + dataItem.Name,
              name: `${dataItem.Code} ${dataItem.Name}`,
            });
          }
          return this.resposibleSubBUList;
        })
      );
    } else {
      return of(this.resposibleSubBUList);
    }
  }


queryChangeControlData(
    filters?: AppliedFilters | null,
    sort?: SortCriteria | null,
    paginationState?: PaginationState
): Observable<ChangeControlQueryResult> {
    // Map filters, sort, and pagination to your API payload
    const base: BaseSearchRequest = this.searchMapper.mapToBaseSearchRequest(filters, sort, paginationState);
    const payload = {
        ...base
        // Add any additional properties required by your API, e.g. ShowAll, ChangeControlNumber, etc.
    };
    return this.httpClient.post<ChangeControlQueryResult>(ApiConstants.ChanageRegister_Search_Api, payload);
}

}


